import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { CountryDataTimeline } from "../models/countrydatatimeline";
import { CountryDataTimelineEventService } from "../services/countrydatatimelineevent.service";

@Injectable()
export class CountryDataTimelineResolver implements Resolve<CountryDataTimeline[]> {
    constructor(private countryDataTimelineEventService: CountryDataTimelineEventService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<CountryDataTimeline[]> {
        return this.countryDataTimelineEventService.getTimeline(route.params["countryCode"]);
    }
}

